<template>
  <section class="footer-cta-section">
    <div class="sec-wrap">
      <h2 class="bnr-ttl text-center" v-if="mode === 'company'">
        <span class="green-txt en">BIB JOB App </span>မှတစ်ဆင့် အလွယ်တကူ ဝန်ထမ်းရှာဖွေပါ
      </h2>
      <h2 class="bnr-ttl text-center" v-else>
        <span class="green-txt en">BIB JOB App </span>မှတစ်ဆင့် အလွယ်တကူ အလုပ်ရှာဖွေပါ
      </h2>
      <div class="footer-cta-banner">
        <!-- Left Side: CV or Post Job CTA -->
        <div class="left-side">
          <div class="cta-info-col">
            <app-icon name="create-cv" size="50" />
            <p class="desc-text" v-if="mode === 'company'">
              အလုပ်ခေါ်ယူမှုများ တင်ပြီး<br />ဝန်ထမ်းများ ရှာဖွေနိုင်ပါတယ်
            </p>
            <p class="desc-text" v-else>
              CV ပြုလုပ်ပြီး<br />အလုပ်လျှောက်နိုင်ပါတယ်
            </p>
            <a :href="actionLink" @click.prevent="onActionClick" class="btn-more-detail">
              <span>အသေးစိတ်ကြည့်ရန်</span>
              <app-icon name="right-arrow" width="10" height="20" />
            </a>
          </div>
          <app-icon name="right-arrow-lg" size="85" class="arrow" />
        </div>

        <!-- Center: Mockup UI -->
        <div class="cta-mockup-col">
          <div class="ui-container">
            <img src="@/assets/images/common/img_mobile_ui_1.png" class="ui-card card-1"
              alt="mobile phone ui design" width="685" height="1377" />
            <img src="@/assets/images/common/img_mobile_ui_2.png" class="ui-card card-2"
              alt="mobile phone ui design" width="685" height="1377" />
            <img src="@/assets/images/common/img_mobile_ui_3.png" class="ui-card card-3"
              alt="mobile phone ui design" width="685" height="1377" />
          </div>
        </div>

        <!-- Right Side: Mobile App Download CTA -->
        <div class="right-side">
          <app-icon name="left-arrow-lg" size="85" class="arrow" />
          <div class="cta-info-col">
            <app-icon name="mobile-app" size="50" />
            <p class="desc-text" v-if="mode === 'company'">
              Mobile App မှလည်း<br />ဝန်ထမ်းရှာဖွေနိုင်ပါတယ်
            </p>
            <p class="desc-text" v-else>
              Mobile App မှာ<br />အလုပ်ရှာနိုင်ပါတယ်
            </p>
            <div class="store-btn-container">
              <a href="https://play.google.com/store/apps/details?id=com.bib.jopapp" class="bnr-store-btn"
                target="_blank" rel="noopener" aria-label="Get it on Google Play">
                <img src="@/assets/images/common/play_store.svg" alt="Get it on Google Play" width="110" height="32" />
              </a>
              <a href="https://apps.apple.com/us/app/bib-job/id1631792469" class="bnr-store-btn" target="_blank"
                rel="noopener" aria-label="Download on App Store">
                <img src="@/assets/images/common/app_store.svg" alt="Download on App Store" width="110" height="32" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppDownloadBanner',
  props: {
    mode: {
      type: String,
      default: 'applicant', // 'applicant' or 'company'
    },
    actionLink: {
      type: String,
      default: '/resume',
    },
  },
  methods: {
    onActionClick(e) {
      this.$emit('action-click', e);
    },
  },
};
</script>
